import MuiTableContainer, { TableContainerProps as MuiTableContainerProps } from '@mui/material/TableContainer';

export type TableContainerProps = MuiTableContainerProps;

export const TableContainer = (props: TableContainerProps) => {
  return <MuiTableContainer {...props} />;
};
